import {useCallback} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {Contact} from "../typedefs";

export function useGetContactGroupContacts(groupID: string) {
    return useCallback(async (search: string, page: number): Promise<PaginatedResponseV2<Contact> | null> => {
        const res = await platformAPI.get<PaginatedResponseV2<Contact>>(`api/contact-groups/${groupID}/contacts`, {
            params: {page, limit: 10, search},
        });
        return res.data;
    }, [groupID]);
}
